export const auth = {
  login: {
    title: "Punto.Firma",
    tagline: "Entra con la cuenta de tu organización.",
    google: "Entrar con Google",
  },
  selectOrganization: {
    title: "¿Con qué organización?",
    description:
      "Tu cuenta pertenece a varias organizaciones. Puedes cambiar más tarde desde el selector de arriba a la izquierda.",
    otherAccount: "Otra cuenta",
    goToPlatform: "Ir a Plataforma",
  },
  noAccess: {
    title: "Sin acceso",
    reasons: {
      // Códigos que el `api` pone en `?reason=` al volver del login con Google.
      domain_not_allowed:
        "Tu dominio de Google no está admitido en ninguna organización de Punto.Firma.",
      not_member:
        "Tu cuenta no está en la lista de ninguna organización. Pide a tu administrador que te invite.",
      suspended: "Tu cuenta está suspendida. Habla con tu administrador.",
      no_organizations:
        "Tu cuenta no pertenece a ninguna organización. Pide a tu administrador que te invite.",
      unknown: "No se ha podido iniciar sesión. Vuelve a intentarlo.",
    },
    otherAccount: "Entrar con otra cuenta",
  },
  connectMac: {
    title: "Conecta Punto.Firma para Mac",
    description:
      "La app usará los certificados que tienes permitidos en {{organization}} como {{email}}.",
    otherOrganization:
      "¿Quieres conectarla con otra organización? Cancela y vuelve a empezar desde la app: te preguntará con cuál.",
    connect: "Conecta este Mac",
    connecting: "Conectando…",
    cancel: "Cancelar",
    done: "Ya puedes volver a la app",
    doneDescription:
      "Punto.Firma para Mac ha recibido el permiso. Puedes cerrar esta ventana.",
    cancelled: "Conexión cancelada",
    cancelledDescription:
      "La app no se ha conectado. Puedes cerrar esta ventana o volver a intentarlo desde la app.",
    invalid: "Este enlace no es válido",
    invalidDescription:
      "Ábrelo desde la app de Punto.Firma para Mac («Entrar con la cuenta de la organización»).",
    expired: "Esta petición ha caducado",
    otherAccount: "No soy {{email}}",
  },
  sessionExpired: "Tu sesión ha caducado. Vuelve a entrar.",
};
